import axios from '@/utils/axios';

const getApplicationStatus = async applicationId => {
	try {
		const {
			data: { loanDecision }
		} = await axios.get(`${process.env.BASE_URL}api/Application/Status/${applicationId}`);

		return loanDecision;
	} catch (error) {
		throw error;
	}
};

const submitApplication = async (applicationId, deviceIdSessionToken) => {
	try {
		const {
			data: { loanDecision, submitCompleted, useSimplifiedLoanOfferView }
		} = await axios.post(`${process.env.BASE_URL}api/Application/Submit`, {
			applicationId,
			deviceIdSessionToken
		});

		return { loanDecision, submitCompleted, useSimplifiedLoanOfferView };
	} catch (error) {
		throw error;
	}
};

const updateApplicationDuplicateAnswer = async (applicationId, applicationDuplicateActionType) => {
	try {
		const {
			data: { updated }
		} = await axios.post(`${process.env.BASE_URL}api/Application/Duplicate/Answer`, {
			applicationId,
			applicationDuplicateActionType
		});

		if (!updated) {
			throw 'There was an error updating the duplicate application answer.';
		}

		return updated;
	} catch (error) {
		throw error;
	}
};

const getLoanOffer = async applicationToken => {
	try {
		const {
			data: { loanOffer, loanApplication, primaryDocumentUploadEnabled, coborrowerDocumentUploadEnabled, missingApplicationToken }
		} = await axios.get(`${process.env.BASE_URL}api/LoanOffer/${applicationToken}`);

		return { loanOffer, loanApplication, primaryDocumentUploadEnabled, coborrowerDocumentUploadEnabled, missingApplicationToken };
	} catch (error) {
		throw error;
	}
};

const getProductEligibilityQuestionConfiguration = async productTypeId => {
	try {
		const {
			data: { questions }
		} = await axios.get(`${process.env.BASE_URL}api/Configuration/ProductType/${productTypeId}/ProductEligibility`);

		return { questions };
	} catch (error) {
		throw error;
	}
};

const getProductTypeId = async applicationId => {
	try {
		const {
			data: { productTypeId }
		} = await axios.get(`${process.env.BASE_URL}api/Application/${applicationId}/ProductTypeId`);

		return productTypeId;
	} catch (error) {
		throw error;
	}
};

const updateLoanPurposeQuestionSelections = async (applicationId, loanPurposeQuestionSelections, businessPurpose) => {
	try {
		const {
			data: { updated }
		} = await axios.post(`${process.env.BASE_URL}api/LoanPurposeQuestions/Update`, {
			applicationId,
			loanPurposeQuestionSelections,
			businessPurpose
		});

		return updated;
	} catch (error) {
		throw error;
	}
};

const getLoanPurposeQuestionSelections = async applicationId => {
	try {
		const {
			data: { loanPurposeQuestionSelections, businessPurpose }
		} = await axios.get(`${process.env.BASE_URL}api/Application/${applicationId}/LoanPurposeQuestions`);

		return { loanPurposeQuestionSelections, businessPurpose };
	} catch (error) {
		throw error;
	}
};


export default {
	getApplicationStatus,
	submitApplication,
	updateApplicationDuplicateAnswer,
	getLoanOffer,
	getProductEligibilityQuestionConfiguration,
	getProductTypeId,
	updateLoanPurposeQuestionSelections,
	getLoanPurposeQuestionSelections
};

export { getApplicationStatus, submitApplication, updateApplicationDuplicateAnswer, getLoanOffer, getProductTypeId, updateLoanPurposeQuestionSelections, getLoanPurposeQuestionSelections };
